import React from 'react';
import { getContext } from 'common';
import LabelContent from '../LabelContent';

export interface SelectItemLabelContentProps extends React.ComponentPropsWithRef<'div'> {
  /** The label content. */
  children: string;
  /** If `true`, the content will be rendered in required style. */
  required?: boolean;
  /** Overrides the required symbol. */
  requiredSymbol?: string;
  /** Overrides the style of the component. */
  style?: React.CSSProperties;
}

/**  Any other props than the `SelectItemLabelContent` props will be provided to the <LabelContent /> component. */
const SelectItemLabelContent = React.forwardRef<HTMLElement, SelectItemLabelContentProps>((props: SelectItemLabelContentProps, ref) => getContext(({ theme }) => {
  const {
    style,
    ...otherProps
  } = props;
  const labelContentProps = {
    ...otherProps,
    style: {
      color: theme.TEXT_INPUT.LABEL,
      ...style
    }
  };
  return (
    <LabelContent ref={ref} {...labelContentProps} />
  );
}));

SelectItemLabelContent.displayName = 'SelectItemLabelContent';

SelectItemLabelContent.defaultProps = {
  required: false,
  requiredSymbol: '*',
  style: {}
};

export default SelectItemLabelContent;